import React, { useState, useEffect } from 'react'
import EmbedVideoYoutube from '@/components/EmbedVideoYoutube'
import EmbedVideoCloudinary from '@/components/EmbedVideoCloudinary'
import IconChevronDown from '@/components/IconChevronDown'
import { createDataLayerIfNotExists } from '../../../utils/global/createDataLayerIfNotExists'

const DESCRIPTION_COLLAPSED_MAX_HEIGHT = 224

interface LongDescriptionInterface {
  (props: {
    video_embed?: string
    dangerouslySetInnerHTML: { __html: string }
    centerTitle: string
    centerSlug: string
  }): JSX.Element
}

const LongDescription: LongDescriptionInterface = ({
  video_embed,
  dangerouslySetInnerHTML,
  centerTitle,
  centerSlug
}) => {
  const [viewMore, setViewMore] = useState(false)

  useEffect(() => {
    const height = document.getElementById('description')?.clientHeight
    if (height && height < DESCRIPTION_COLLAPSED_MAX_HEIGHT) {
      setViewMore(true)
    }
  }, [])

  const handleDataLayerClick = () => {
    createDataLayerIfNotExists()
    window?.dataLayer?.push({ ecommerce: null })
    window?.dataLayer?.push({
      center_title: centerTitle,
      center_slug: centerSlug,
      event: 'Long Description Read More'
    })
  }

  const videoType = video_embed?.includes('cloudinary.com')
    ? 'cloudinary'
    : 'youtube'

  return (
    <div className="mx-auto flex w-full max-w-[1200px] flex-wrap md:flex-nowrap">
      <div className="w-full md:w-[55%] md:pr-14">
        <p className="mb-0 max-w-[900px] text-left text-3xl font-semibold text-gray-1100">
          About {centerTitle}
        </p>
        <div
          className={`prose-long-description relative mx-auto max-w-[1200px] overflow-hidden ${
            !viewMore ? 'max-h-[224px]' : ''
          }`}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ ...dangerouslySetInnerHTML }}
          id="description"
        />
        {!viewMore && (
          <p
            id="ReadMoreId"
            className="mb-8 mt-4 flex cursor-pointer items-center text-lg font-semibold text-gray-1100 underline sm:no-underline md:mb-0 md:hover:underline"
            onClick={() => {
              setViewMore(true)
              handleDataLayerClick()
            }}
          >
            <span className="mr-1">Read More</span>
            <IconChevronDown size="md" />
          </p>
        )}
      </div>
      {video_embed && (
        <div className="w-full md:w-[45%]">
          {videoType === 'cloudinary' ? (
            <EmbedVideoCloudinary video_embed={video_embed} />
          ) : (
            <EmbedVideoYoutube id={video_embed} />
          )}
        </div>
      )}
    </div>
  )
}

export default LongDescription
